import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import type { App, Plugin } from "vue";

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $CookieConsent: typeof CookieConsent;
  }
}

const CookieConsentPlugin: Plugin = {
  install: (app: App, pluginConfig: any) => {
    app.config.globalProperties.$CookieConsent = CookieConsent;
    app.config.globalProperties.$CookieConsent.run(pluginConfig);
  },
};

export default CookieConsentPlugin;
